import React from 'react';

interface LoadingSpinnerProps {
  /** Text to display below the spinner */
  message?: string;
  /** Size of the spinner */
  size?: 'sm' | 'md' | 'lg';
  /** Whether to center the spinner */
  centered?: boolean;
  /** Whether to show with fullscreen background */
  fullscreen?: boolean;
  /** Custom className for the container */
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
  size = 'md',
  centered = true,
  fullscreen = false,
  className = '',
}) => {
  const sizeClasses = {
    sm: 'h-5 w-5',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  const spinnerElement = (
    <div className="text-center">
      <div
        data-testid="loading-spinner"
        className={`border-muted-foreground mx-auto animate-spin rounded-full border-b-2 ${sizeClasses[size]} ${message ? 'mb-3' : ''} `}
      />
      {message && <p className="text-muted-foreground text-sm">{message}</p>}
    </div>
  );

  if (fullscreen) {
    return (
      <div className={`bg-muted flex min-h-screen items-center justify-center ${className}`}>
        {spinnerElement}
      </div>
    );
  }

  if (centered) {
    return <div className={`flex items-center justify-center ${className}`}>{spinnerElement}</div>;
  }

  return <div className={className}>{spinnerElement}</div>;
};

export default LoadingSpinner;
